const hotelRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/hotel', // 酒店主页
      name: 'HotelHome',
      component: () => import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel')
    },
    {
      path: '/hotel/book/:id', // 酒店预定
      name: 'HotelBook',
      component: () =>
        import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel/hotelBook')
    },
    {
      path: '/hotel/info', // 酒店详情
      name: 'HotelInfo',
      component: () =>
        import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel/hotelInfo')
    },
    {
      path: '/hotel/order', // 酒店下订单
      name: 'HotelOrder',
      component: () =>
        import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel/hotelOrder')
    },
    {
      path: '/hotel/pay', // 酒店付款
      name: 'HotelPay',
      component: () =>
        import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel/hotelPay')
    },
    {
      path: '/hotel/hotelPayResult', // 酒店支付反馈页面
      name: 'HotelPayResult',
      component: () =>
        import(/* webpackChunkName: "hotel" */ '@/pages/welcomeToYiwu/hotel/hotelPayResult')
    }
  ]
}
export default hotelRouter
